/**
 * @description
 * Dealer's Insights api list
 */
const leadsApiBase = '/dealer-portal/insights';
const devLeadsApiBase = `http://localhost:5000${leadsApiBase}`;

/* istanbul ignore next */
const apiBase = process.env.REACT_APP_MOCK_SERVER
  ? devLeadsApiBase
  : leadsApiBase;

export const DEALERS_INSIGHTS_TIME_DIVISIONS = {
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
};

export const DEALERS_INSIGHTS_FEATURES = {
  LEADS: 'leads',
  LISTINGS: 'listings',
};

/**
 * @todo improve this - create a selector for formatting the
 * api `date` param and pass it from the saga
 * instead of formatting it here
 */

/**
 * @typedef {Object} DealersInsightsParams
 * @property {number} [size] - # of top listings to show
 * @property {'month'|'year'} [tdiv] - time division filter
 * @property {string} [date] - date in yyyy-mm to filter by
 * @property {number} [year] - year to filter by
 */

/**
 *
 * @param {string} path
 * @returns {(params: DealersInsightsParams) => string}
 */
export const prepareUrl = (path) => (params) => {
  const queryParams = new URLSearchParams(params);
  const preparedParams = queryParams.toString();
  const urlBase = `${apiBase}/${path}`;

  if (preparedParams?.length === 0) {
    return urlBase;
  }
  return `${urlBase}?${preparedParams}`;
};

const DEALERS_INSIGHTS_API = {
  dateRange: prepareUrl('getFirstLast'),
  leads: prepareUrl('leads'),
  leadsYearChart: prepareUrl('leads/yearChart'),
  listings: prepareUrl('listings'),
  listingsImages: prepareUrl('listings/images'),
  topListings: prepareUrl('listings/top'),
  listingsTurnover: prepareUrl('listings/turnover'),
};

export default DEALERS_INSIGHTS_API;
